import React, { useState, useContext, useEffect } from 'react';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import {
  ContentWrapper,
  SideBar,
  SideBarOpenIconContainer,
  ContentContainer,
  SideBarContainer,
  CustomDivider,
  SideBarTitle,
  SideBarCardText,
  ReturnMethodContainer,
  ReturnMethodItem,
  ButtonContainer,
} from './styles';

import Map from './components/Map';
import SideBarCard from './components/CustomSideBarCard';
import ItemDetailsRow from './components/CustomItemDetailsRow';
import { CardLocker } from './components/CardLocker';

import CrLogo from '../../../../assets/images/LogoCliqueHorizontal.svg';
import CorreiosLogo from '../../../../assets/images/logoCorreiosLabel.png';

import { dateFormat } from '../../../../core/utils/dateFormat';
import { CustomButton } from '../../../PublicOrderCreation/components/Content/styles';
import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { CircularProgress } from '@material-ui/core';
import useWindowSize from '../../../../shared/hooks/useWindowSize';
import useCurrentLocation from '../../../../shared/hooks/useCurrentLocation';
import usePageStore from '../../store/pageStore';
import Services from '../../services';
import useConfigsStore from '../../store/configsStore';
import DevolutionInstructions from './components/DevolutionInstructions';

export default function Content({ submit }) {
  const { setInfoMessage } = useContext(GeneralContext);
  const { width: windowWidth } = useWindowSize();
  const { location: currentLocation } = useCurrentLocation();

  const storeId = useConfigsStore((state) => state.storeId);
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );
  const integrationStatus = useConfigsStore((state) => state.integrationStatus);
  const orderInfo = useConfigsStore((state) => state.order);
  const lockersInfo = useConfigsStore((state) => state.lockersInfo);
  const setLoadingLockersInfo = useConfigsStore(
    (state) => state.setLoadingLockersInfo,
  );
  const setLockersInfo = useConfigsStore((state) => state.setLockersInfo);
  const loadingLockersInfo = useConfigsStore(
    (state) => state.loadingLockersInfo,
  );

  const isProcessingOrder = usePageStore((state) => state.isProcessingOrder);
  const selectedReturnMethod = usePageStore(
    (state) => state.selectedReturnMethod,
  );
  const setSelectedReturnMethod = usePageStore(
    (state) => state.setSelectedReturnMethod,
  );
  const selectedLocker = usePageStore((state) => state.selectedLocker);
  const setSelectedLocker = usePageStore((state) => state.setSelectedLocker);

  const handleGetLockersByZipCode = async (zipCode) => {
    setLoadingLockersInfo(true);
    //TODO the storeId should be removed - it's hardcoded the devolution zones until the feature is implemented
    const lockersInfoResult = await Services.getLockersByZipCode(
      storeId,
      zipCode,
    );
    if (lockersInfoResult) {
      setLockersInfo(lockersInfoResult);
    } else {
      setInfoMessage(
        'Não foi possível carregar os lockers, tente novamente mais tarde.',
      );
    }
    setLoadingLockersInfo(false);
  };

  const isCorreiosEnabled = integrationStatus?.correios ?? false;

  const [openLockerCard, setOpenLockerCard] = useState(false);
  const [clickedLocker, setClickedLocker] = useState('');
  const [isSideBarOpen, setIsSideBarOpen] = useState(
    isCorreiosEnabled ?? false,
  );

  //TODO: Refactor this... it's a mess and provokes unecessary re-renders, try to follow the async await pattern...
  useEffect(() => {
    if (!isCorreiosEnabled && selectedLocker) {
      submit();
    }
  }, [selectedLocker]);

  return (
    <ContentWrapper>
      <SideBar isSideBarOpen={isSideBarOpen}>
        <SideBarOpenIconContainer
          onClick={() => setIsSideBarOpen((prev) => !prev)}
          isSideBarOpen={isSideBarOpen}
        >
          <KeyboardArrowRightIcon />
        </SideBarOpenIconContainer>
        <SideBarContainer>
          <SideBarTitle fontFamily={devolutionPageConfigs?.fontFamily}>
            Informações da devolução
          </SideBarTitle>
          <SideBarCard>
            <SideBarCardText
              fontFamily={devolutionPageConfigs?.fontFamily}
            >{`N° devolução: ${orderInfo?.code ?? 'N/A'}`}</SideBarCardText>
            <SideBarCardText
              fontFamily={devolutionPageConfigs?.fontFamily}
            >{`Email cliente: ${
              orderInfo?.client?.email ?? 'N/A'
            }`}</SideBarCardText>
            <SideBarCardText
              fontFamily={devolutionPageConfigs?.fontFamily}
            >{`Criado em: ${
              orderInfo?.orderDate ? dateFormat(orderInfo.orderDate) : 'N/A'
            }`}</SideBarCardText>
            <SideBarCardText
              fontFamily={devolutionPageConfigs?.fontFamily}
            >{`N° pedido: ${
              orderInfo?.externalOrderCode ?? 'N/A'
            }`}</SideBarCardText>
          </SideBarCard>
          <CustomDivider />
          <SideBarTitle fontFamily={devolutionPageConfigs?.fontFamily}>
            Método de devolução
          </SideBarTitle>
          <ReturnMethodContainer>
            <ReturnMethodItem
              isSelected={selectedReturnMethod === 1}
              borderColor={devolutionPageConfigs?.primaryColor}
              onClick={() => {
                if (selectedReturnMethod !== 1) setSelectedReturnMethod(1);
              }}
            >
              <img alt="crlogo" src={CrLogo} style={{ width: 70 }} />
            </ReturnMethodItem>
            {isCorreiosEnabled && (
              <ReturnMethodItem
                isSelected={selectedReturnMethod === 2}
                borderColor={devolutionPageConfigs?.primaryColor}
                onClick={() => {
                  if (selectedReturnMethod !== 2) setSelectedReturnMethod(2);
                }}
              >
                <img
                  alt="correioslogo"
                  src={CorreiosLogo}
                  style={{ width: 70 }}
                />
              </ReturnMethodItem>
            )}
          </ReturnMethodContainer>
          {selectedLocker && selectedReturnMethod === 1 && (
            <>
              <CustomDivider />
              <SideBarCard>
                <SideBarCardText
                  fontFamily={devolutionPageConfigs?.fontFamily}
                >{`Locker: ${selectedLocker.name}`}</SideBarCardText>
                <SideBarCardText
                  fontFamily={devolutionPageConfigs?.fontFamily}
                >{`Ebox: ${selectedLocker.boxCode}`}</SideBarCardText>
                <SideBarCardText
                  fontFamily={devolutionPageConfigs?.fontFamily}
                >{`Endereço: ${selectedLocker.address}`}</SideBarCardText>
              </SideBarCard>
            </>
          )}
          <CustomDivider />
          {orderInfo?.items && orderInfo?.items.length > 0 && (
            <>
              <SideBarTitle fontFamily={devolutionPageConfigs?.fontFamily}>
                Items do pedido
              </SideBarTitle>
              <SideBarCard>
                <ItemDetailsRow
                  key="header"
                  name="Item"
                  quantity="Quantidade"
                  price="Preço"
                  disableFormatPrice
                  bold
                  fontFamily={devolutionPageConfigs?.fontFamily}
                />
                {orderInfo.items.map((item) => (
                  <ItemDetailsRow
                    key={item.id}
                    name={item.name}
                    quantity={item.quantity}
                    price={item.price}
                    fontFamily={devolutionPageConfigs?.fontFamily}
                  />
                ))}
              </SideBarCard>
            </>
          )}
          {isCorreiosEnabled && (
            <ButtonContainer>
              <CustomButton
                color={devolutionPageConfigs?.primaryColor}
                secondaryColor={devolutionPageConfigs?.secondaryColor}
                disable={selectedReturnMethod === 1 && !selectedLocker}
                onClick={async () => {
                  if (selectedReturnMethod === 1 && !selectedLocker) {
                    setInfoMessage('Selecione um locker para continuar');
                    if (windowWidth <= 768) {
                      setIsSideBarOpen(false);
                    }
                  } else {
                    await submit();
                  }
                }}
              >
                {isProcessingOrder ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  'Finalizar devolução'
                )}
              </CustomButton>
            </ButtonContainer>
          )}
        </SideBarContainer>
      </SideBar>
      <ContentContainer isSideBarOpen={isSideBarOpen}>
        <DevolutionInstructions />
        <Map
          onCardClicked={(lockerData) => {
            setClickedLocker(lockerData);
            setOpenLockerCard(true);
          }}
          lockersInfo={lockersInfo ?? []}
          searchZipCode={handleGetLockersByZipCode}
          searchIconColor={devolutionPageConfigs?.primaryColor}
          fontFamily={devolutionPageConfigs?.fontFamily}
          isLockersInfoLoading={loadingLockersInfo}
          currentLocation={currentLocation}
          fontColorSecondary={devolutionPageConfigs?.fontColorSecondary}
          mapContainerSize={{
            width: '100%',
            height: '100%',
          }}
        />
        <CardLocker
          open={openLockerCard}
          devolutionPageConfigs={devolutionPageConfigs}
          lockerData={clickedLocker}
          handleClose={() => setOpenLockerCard(false)}
          buttonText={
            isCorreiosEnabled ? 'Selecionar locker' : 'Criar devolução'
          }
          loading={!isCorreiosEnabled && isProcessingOrder}
          onLockerSelected={(address, boxCode, name) => {
            setSelectedLocker({ address, boxCode, name });
            if (isCorreiosEnabled) {
              setOpenLockerCard(false);
              if (windowWidth <= 768) {
                setIsSideBarOpen(true);
              }
            }
          }}
          currentLocation={currentLocation}
        />
      </ContentContainer>
    </ContentWrapper>
  );
}
